import { render, staticRenderFns } from "./PopUpChoix.vue?vue&type=template&id=f222bd22&scoped=true"
import script from "./PopUpChoix.vue?vue&type=script&lang=js"
export * from "./PopUpChoix.vue?vue&type=script&lang=js"
import style0 from "./PopUpChoix.vue?vue&type=style&index=0&id=f222bd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f222bd22",
  null
  
)

export default component.exports